import React from 'react'
import PropTypes from 'prop-types'
import {
  ActionBarContainer,
  MainContainer,
  ListItemContainer,
  TotalRow,
  TotalLabel,
  TotalValue,
  DetailsContainer,
  DetailRow,
  DetailLabel,
  DetailValue,
  ActionsContainer,
  AcceptButton,
  ButtonText,
  BottomSpacer
} from './styles'

export const MobileActionBar = ({
  totalLabel = 'Total pago a prazo',
  totalValue,
  validityDate,
  entryValue,
  installmentsText,
  buttonText = 'Aceitar proposta',
  onAccept,
  disabled = false,
  isLoading = false
}) => {
  if (isLoading) {
    return null
  }

  return (
    <ActionBarContainer>
      <MainContainer>
        <ListItemContainer>
          <TotalRow>
            <TotalLabel>{totalLabel}</TotalLabel>
            <TotalValue>{totalValue || '-'}</TotalValue>
          </TotalRow>
          <DetailsContainer>
            {validityDate && (
              <DetailRow>
                <DetailLabel>Validade da proposta</DetailLabel>
                <DetailValue>{validityDate}</DetailValue>
              </DetailRow>
            )}
            {entryValue && (
              <DetailRow>
                <DetailLabel>Entrada</DetailLabel>
                <DetailValue>{entryValue}</DetailValue>
              </DetailRow>
            )}
            {installmentsText && (
              <DetailRow>
                <DetailLabel>Parcelas</DetailLabel>
                <DetailValue>{installmentsText}</DetailValue>
              </DetailRow>
            )}
          </DetailsContainer>
        </ListItemContainer>
        <ActionsContainer>
          <AcceptButton onClick={onAccept} disabled={disabled}>
            <ButtonText>{buttonText}</ButtonText>
          </AcceptButton>
        </ActionsContainer>
      </MainContainer>
      <BottomSpacer />
    </ActionBarContainer>
  )
}

MobileActionBar.propTypes = {
  totalLabel: PropTypes.string,
  totalValue: PropTypes.string,
  validityDate: PropTypes.string,
  entryValue: PropTypes.string,
  installmentsText: PropTypes.string,
  buttonText: PropTypes.string,
  onAccept: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool
}
